(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3075,7792],{

/***/ 35456:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-engine",
      function () {
        return __webpack_require__(53962);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ StyledFaqsHeader; },
/* harmony export */   "Ie": function() { return /* binding */ StyledWebFaqs; },
/* harmony export */   "s5": function() { return /* binding */ StyledFaqsSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99655);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: auto;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  max-width: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: auto;\n  max-width: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  counter-reset: faqs;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledFaqsSection = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73f69e31-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl6"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledFaqsHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73f69e31-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("lg"), components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Heading2 */ .XJ, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"));
var StyledWebFaqs = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dl.withConfig */ .ZP.dl.withConfig({
    componentId: "sc-73f69e31-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_200"));


/***/ }),

/***/ 29372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_marketingSite_shared_FaqsItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53307);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99655);
/* harmony import */ var _Faqs_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12109);




var Faqs = function(param) {
    var faqs = param.faqs, title = param.title, desc = param.desc, h3 = param.h3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs && faqs.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFaqsSection */ .s5, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFaqsHeader */ .$t, {
                    children: [
                        !h3 && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Heading2 */ .XJ, {
                            editorial: true,
                            children: title
                        }),
                        h3 && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                            editorial: true,
                            children: title
                        }),
                        desc && typeof desc === "object" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: desc
                        }),
                        typeof desc === "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: desc || ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledWebFaqs */ .Ie, {
                    children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_marketingSite_shared_FaqsItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            renderComponent: faq.renderComponent,
                            question: faq.question,
                            answer: faq.answer,
                            anchor: faq.anchor,
                            active: faq.active
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Faqs);


/***/ }),

/***/ 670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StyledMarkdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ul,\n  ol {\n    padding-left: ",
        " !important;\n\n    li {\n      margin-bottom: ",
        ";\n      margin-top: 0 !important;\n    }\n  }\n\n  ul {\n    li {\n      list-style-type: disc;\n    }\n  }\n\n  ol {\n    li {\n      list-style-type: numeric;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledMarkdown = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-da6035b2-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));


/***/ }),

/***/ 57792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MarkdownComponent": function() { return /* binding */ MarkdownComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84864);
/* harmony import */ var rehype_external_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78313);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5636);
/* harmony import */ var _MarkdownComponent_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(670);





var ALLOWED_ELEMENTS = [
    "p",
    "strong",
    "ul",
    "ol",
    "li",
    "em",
    "a",
    "br",
    "img",
    "u",
    "blockquote"
];
var MarkdownComponent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MarkdownComponent_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledMarkdown */ .F, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_2__/* .ReactMarkdown */ .D, {
            allowedElements: ALLOWED_ELEMENTS,
            rehypePlugins: [
                [
                    rehype_external_links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                    {
                        target: "_blank"
                    }
                ],
                rehype_raw__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
            ],
            children: content
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MarkdownComponent);


/***/ }),

/***/ 53962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ talent_engine; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./components/shared/MarkdownComponent.tsx
var MarkdownComponent = __webpack_require__(57792);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./components/marketingSite/shared/Faqs.tsx
var Faqs = __webpack_require__(29372);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/features/Features.constants.tsx

var FEATURESITEMS = function(t) {
    return [
        {
            title: t("talent-engine-landing.features.feature1-title"),
            desc: "talent-engine-landing.features.feature1-desc",
            image: (0,paths/* getPublicPath */.A)("/images/talentEngine/landing-feature1.jpg"),
            imageSm: (0,paths/* getPublicPath */.A)("/images/talentEngine/landing-feature1-sm.png")
        },
        {
            title: t("talent-engine-landing.features.feature2-title"),
            desc: "talent-engine-landing.features.feature2-desc",
            image: (0,paths/* getPublicPath */.A)("/images/talentEngine/landing-feature2.jpg"),
            imageSm: (0,paths/* getPublicPath */.A)("/images/talentEngine/landing-feature2-sm.png")
        },
        {
            title: t("talent-engine-landing.features.feature3-title"),
            desc: "talent-engine-landing.features.feature3-desc",
            image: (0,paths/* getPublicPath */.A)("/images/talentEngine/landing-feature3.jpg"),
            imageSm: (0,paths/* getPublicPath */.A)("/images/talentEngine/landing-feature3-sm.png")
        },
        {
            title: t("talent-engine-landing.features.feature4-title"),
            desc: "talent-engine-landing.features.feature4-desc",
            image: (0,paths/* getPublicPath */.A)("/images/talentEngine/landing-feature4.jpg"),
            imageSm: (0,paths/* getPublicPath */.A)("/images/talentEngine/landing-feature4.jpg")
        }
    ];
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/features/Features.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        " 0 ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: 58rem;\n  margin: auto;\n  line-height: 1.5;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ",
        " ",
        " 0;\n\n  @media (min-width: ",
        ") {\n    justify-content: flex-start;\n    padding: 0;\n  }\n\n  img {\n    display: block;\n\n    &.desktop {\n      display: none;\n    }\n\n    @media (min-width: ",
        ") {\n      width: 100%;\n\n      &.mobile {\n        display: none;\n      }\n      &.desktop {\n        display: block;\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 ",
        " ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: ",
        " ",
        " ",
        " 0;\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    gap: ",
        ";\n    font-size: ",
        ";\n\n    &:nth-of-type(odd) {\n      ",
        " {\n        @media (min-width: ",
        ") {\n          order: 1;\n          justify-content: flex-end;\n        }\n      }\n\n      ",
        " {\n        @media (min-width: ",
        ") {\n          padding: ",
        " 0 ",
        " ",
        ";\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 0rem;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: 2rem;\n  }\n\n  > div {\n    flex: 1 1 auto;\n  }\n\n  > div:first-child {\n    flex: 1 0 50%;\n  }\n\n  li {\n    list-style-type: disc;\n    margin-left: 1.5rem;\n  }\n\n  img {\n    max-width: 80%;\n    height: auto;\n    margin: 2rem auto;\n    display: block;\n  }\n\n  display: flex;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  img {\n    margin-bottom: ",
        ";\n  }\n\n  p {\n    line-height: 1.5;\n    color: ",
        ";\n    margin-top: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n      line-height: 1.6;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d0d4df3-0"
})(_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d0d4df3-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledFeatureList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d0d4df3-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"));
var StyledFeatureImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d0d4df3-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("lg"));
var StyledFeatureContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d0d4df3-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), Typography_styled/* Heading3 */.aC, (0,theme/* spacing */.W0)("md"));
var StyledFeature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d0d4df3-5"
})(_templateObject5(), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("white"), (0,theme/* radius */.q0)("lg"), (0,theme/* shadow */.AF)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* fontSize */.JB)("lg"), StyledFeatureImage, (0,theme/* screen */.sp)("lg"), StyledFeatureContent, (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"));
var StyledStep = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d0d4df3-6"
})(_templateObject6(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"));
var StyledCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d0d4df3-7"
})(_templateObject7(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/features/Features.tsx












var TEFeatures = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-engine-landing-v3").t;
    var features = FEATURESITEMS(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading2 */.XJ, {
                        editorial: true,
                        children: t("talent-engine-landing.features.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "talent-engine-landing-v3",
                        i18nKey: "talent-engine-landing.features.desc"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeatureList, {
                children: features.map(function(feature, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeature, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeatureImage, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: feature.image,
                                        alt: "",
                                        className: "desktop"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: feature.imageSm,
                                        alt: "",
                                        className: "mobile"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeatureContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                                        editorial: true,
                                        alignLeft: true,
                                        children: feature.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                        ns: "talent-engine-landing-v3",
                                        i18nKey: feature.desc
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "talentEngineConsultancy",
                id: "talentEngineConsultancy",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStep, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading2 */.XJ, {
                                    editorial: true,
                                    alignLeft: true,
                                    children: t("talent-engine-landing.steps.step1.subtitle")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "talent-engine-landing-v3",
                                    i18nKey: "talent-engine-landing.steps.step1.content"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                        to: "talentEngineForm",
                                        href: "#talentEngineForm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                                            variant: "brandTalent",
                                            as: "div",
                                            sizes: "s",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("talent-engine-landing.steps.step1.cta2")
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,paths/* getPublicPath */.A)("/images/talentEngine/te-step1.png")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCta, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/talentEngine/vitamines.png"),
                        alt: "",
                        width: "240"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                        children: t("talent-engine-landing.features.cta.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "talent-engine-landing",
                        i18nKey: t("talent-engine-landing.features.cta.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                        to: "talentEngineForm",
                        href: "#talentEngineForm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                            variant: "brandTalent",
                            as: "div",
                            onClick: function() {
                                return service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("talent-engine-quiero-descubre");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("talent-engine-landing.features.cta.cta")
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Features = (TEFeatures);

// EXTERNAL MODULE: ./components/marketingSite/talentEngineV3/sections/footer/TalentEngineFooter.tsx + 7 modules
var TalentEngineFooter = __webpack_require__(65602);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/hero/Hero.styled.tsx

function Hero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: linear-gradient(\n    180deg,\n    ",
        " 18%,\n    ",
        " 100%\n  );\n  padding: ",
        " ",
        " ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: ",
        " ",
        " ",
        ";\n  }\n"
    ]);
    Hero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Hero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  position: relative;\n  overflow: hidden;\n  max-width: 55rem;\n  width: 100%;\n"
    ]);
    Hero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Hero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    Hero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Hero_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 54rem;\n  color: ",
        ";\n  text-align: center;\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    Hero_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Hero_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    Hero_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e6d4564f-0"
})(Hero_styled_templateObject(), (0,theme/* color */.$_)("cyan_900"), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl6"));
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-e6d4564f-1"
})(Hero_styled_templateObject1(), (0,theme/* radius */.q0)("md"));
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e6d4564f-2"
})(Hero_styled_templateObject2(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl2"));
var StyledHeroText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e6d4564f-3"
})(Hero_styled_templateObject3(), (0,theme/* color */.$_)("text_white"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl"), ButtonLink_styled/* default */.C, (0,theme/* spacing */.W0)("lg"));
var StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-e6d4564f-4"
})(Hero_styled_templateObject4(), (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/hero/Hero.tsx










var TEHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-engine-landing-v3").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHero, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroText, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroTitle, {
                            children: t("talent-engine-landing.hero.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "talent-engine-landing-v3",
                            i18nKey: "talent-engine-landing.hero.desc"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                            to: "talentEngineForm",
                            href: "#talentEngineForm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                                variant: "primary",
                                as: "div",
                                onClick: function() {
                                    return service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("talent-engine-quiero-hero");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("talent-engine-landing.hero.cta")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    src: (0,paths/* getPublicPath */.A)("/images/talentEngine/kanban-mock.png")
                })
            ]
        })
    });
};
/* harmony default export */ var Hero = (TEHero);

// EXTERNAL MODULE: ./components/marketingSite/talentEngineV3/sections/nav/Nav.tsx + 3 modules
var Nav = __webpack_require__(463);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/steps/Steps.styled.ts

function Steps_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        " 0 ",
        ";\n"
    ]);
    Steps_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Steps_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  flex-direction: row;\n  gap: 2rem;\n  margin-bottom: 4rem;\n\n  @media (min-width: ",
        ") {\n    display: flex;\n  }\n"
    ]);
    Steps_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Steps_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  padding: ",
        ";\n  text-align: center;\n  flex: 1 1 100%;\n  margin-bottom: ",
        ";\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @media (min-width: ",
        ") {\n    width: 50%;\n    margin-bottom: 0;\n    flex: 1 1 50%;\n  }\n\n  h3 {\n    margin-bottom: 1.5rem;\n  }\n\n  img {\n    display: block;\n    max-width: 308px;\n    margin: 0 auto ",
        " auto;\n  }\n\n  strong {\n    display: block;\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    Steps_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Steps_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 0rem;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: 2rem;\n  }\n\n  li {\n    list-style-type: disc;\n    margin-left: 1.5rem;\n  }\n\n  img {\n    width: 100%;\n    height: auto;\n    margin: 2rem auto;\n    display: block;\n  }\n\n  > div:last-child {\n    flex: 1 0 auto;\n    max-width: 40%;\n  }\n\n  display: ",
        ";\n"
    ]);
    Steps_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Steps_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.12;\n  margin: 0;\n"
    ]);
    Steps_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Steps_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: 58rem;\n  margin: auto;\n  line-height: 1.5;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    Steps_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Steps_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n"
    ]);
    Steps_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Steps_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ",
        " ",
        " 0;\n\n  @media (min-width: ",
        ") {\n    justify-content: flex-start;\n    padding: 0;\n  }\n\n  img {\n    display: block;\n\n    &.desktop {\n      display: none;\n    }\n\n    @media (min-width: ",
        ") {\n      width: 100%;\n\n      &.mobile {\n        display: none;\n      }\n      &.desktop {\n        display: block;\n      }\n    }\n  }\n"
    ]);
    Steps_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 ",
        " ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: ",
        " ",
        " ",
        " 0;\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    gap: ",
        ";\n    font-size: ",
        ";\n\n    &:nth-of-type(odd) {\n      ",
        " {\n        @media (min-width: ",
        ") {\n          order: 1;\n          justify-content: flex-end;\n        }\n      }\n\n      ",
        " {\n        @media (min-width: ",
        ") {\n          padding: ",
        " 0 ",
        " ",
        ";\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  img {\n    margin-bottom: ",
        ";\n  }\n\n  p {\n    line-height: 1.5;\n    color: ",
        ";\n    margin-top: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n      line-height: 1.6;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var Steps_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f89eee-0"
})(Steps_styled_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledTabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f89eee-1"
})(Steps_styled_templateObject1(), (0,theme/* screen */.sp)("lg"));
var StyledTab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f89eee-2"
})(Steps_styled_templateObject2(), (0,theme/* color */.$_)("white"), (0,theme/* radius */.q0)("lg"), (0,theme/* shadow */.AF)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("md"));
var Steps_styled_StyledStep = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f89eee-3"
})(Steps_styled_templateObject3(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), function(param) {
    var visible = param.visible;
    return visible ? "flex" : "none";
});
var StyledStepHead = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-d7f89eee-4"
})(Steps_styled_templateObject4(), (0,theme/* fontFamily */.I8)("sans-serif"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("xl"));
var Steps_styled_StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f89eee-5"
})(Steps_styled_templateObject5(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var Steps_styled_StyledFeatureList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f89eee-6"
})(Steps_styled_templateObject6(), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"));
var Steps_styled_StyledFeatureImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f89eee-7"
})(Steps_styled_templateObject7(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("lg"));
var Steps_styled_StyledFeatureContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f89eee-8"
})(_templateObject8(), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), Typography_styled/* Heading3 */.aC, (0,theme/* spacing */.W0)("md"));
var Steps_styled_StyledFeature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f89eee-9"
})(_templateObject9(), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("white"), (0,theme/* radius */.q0)("lg"), (0,theme/* shadow */.AF)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* fontSize */.JB)("lg"), Steps_styled_StyledFeatureImage, (0,theme/* screen */.sp)("lg"), Steps_styled_StyledFeatureContent, (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"));
var Steps_styled_StyledCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f89eee-10"
})(_templateObject10(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/steps/Steps.tsx










var TESteps = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-engine-landing-v3").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Steps_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps_styled_StyledHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading2 */.XJ, {
                    editorial: true,
                    children: t("talent-engine-landing.steps.title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Steps_styled_StyledFeatureList, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabs, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTab, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,paths/* getPublicPath */.A)("/images/talentEngine/te-step1.png")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                                        editorial: true,
                                        children: t("talent-engine-landing.steps.step1.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                        to: "talentEngineConsultancy",
                                        href: "#talentEngineConsultancy",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                            variant: "brandTalent",
                                            as: "div",
                                            sizes: "s",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_solid_svg_icons/* faArrowCircleDown */.DY
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("talent-engine-landing.steps.step1.cta")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTab, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,paths/* getPublicPath */.A)("/images/talentEngine/te-step2.png")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                                        editorial: true,
                                        children: t("talent-engine-landing.steps.step2.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                        to: "talentEngineForm",
                                        href: "#talentEngineForm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                            variant: "brandTalent",
                                            as: "div",
                                            sizes: "s",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_solid_svg_icons/* faArrowCircleDown */.DY
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("talent-engine-landing.steps.step2.cta")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Steps_styled_StyledStep, {
                        visible: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                                        editorial: true,
                                        alignLeft: true,
                                        children: t("talent-engine-landing.steps.step2.subtitle")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                        ns: "talent-engine-landing-v3",
                                        i18nKey: "talent-engine-landing.steps.step2.content"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                            to: "talentEngineForm",
                                            href: "#talentEngineForm",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                                variant: "brandTalent",
                                                as: "div",
                                                sizes: "s",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("talent-engine-landing.steps.step2.cta2")
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,paths/* getPublicPath */.A)("/images/talentEngine/te-step3.png")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/TalentEngineComponent.styled.tsx

function TalentEngineComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: ",
        ";\n"
    ]);
    TalentEngineComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b3810a2-0"
})(TalentEngineComponent_styled_templateObject(), (0,theme/* color */.$_)("midnight_100"));

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/TalentEngineComponent.tsx











var TalentEngineComponent = function(param) {
    var faqs = param.faqs;
    var t = (0,useI18n/* useI18n */.Q)("talent-engine-landing-v3").t;
    var faqsArray = (faqs === null || faqs === void 0 ? void 0 : faqs.sort(function(a, b) {
        return a.attributes.order - b.attributes.order;
    }).map(function(faq) {
        return {
            question: faq.attributes.question,
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                content: faq.attributes.answer
            }),
            renderComponent: true
        };
    })) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        pageVariant: "light",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TESteps, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs/* default */.Z, {
                    faqs: faqsArray,
                    title: t("talent-engine-landing.faqs.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentEngineFooter/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var talentEngineV3_TalentEngineComponent = (TalentEngineComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./pages/talent-engine/index.tsx









var parseJSON = function(resp) {
    return resp.json ? resp.json() : resp;
};
var checkStatus = function(resp) {
    if (resp.status >= 200 && resp.status < 300) {
        return resp;
    }
    return parseJSON(resp).then(function(resp) {
        throw resp;
    });
};
var headers = {
    "Content-Type": "application/json"
};
var TalentEngineLandingPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("talent-engine-landing-v3").t;
    var locale = (0,router.useRouter)().locale;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    var ref = (0,react.useState)([]), customers = ref[0], setCustomers = ref[1];
    var ref1 = (0,react.useState)([]), faqs = ref1[0], setFaqs = ref1[1];
    (0,react.useEffect)(function() {
        fetch("https://cms.getmanfred.com/api/talent-engine-page-customers?populate=%2A&pagination[pageSize]=100", {
            headers: headers,
            method: "GET"
        }).then(checkStatus).then(parseJSON).then(function(param) {
            var data = param.data;
            return setCustomers(data);
        });
    }, []);
    (0,react.useEffect)(function() {
        fetch("https://cms.getmanfred.com/api/talent-engine-page-faqs?populate=%2A&pagination[pageSize]=100&locale=".concat(locale), {
            headers: headers,
            method: "GET"
        }).then(checkStatus).then(parseJSON).then(function(param) {
            var data = param.data;
            return setFaqs(data);
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("talent-engine-landing.page_title"),
                url: app_urls/* APP_URLS.talentEngineLanding */.uu.talentEngineLanding,
                desc: t("talent-engine-landing.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_talent_engine.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(talentEngineV3_TalentEngineComponent, {
                customers: customers,
                faqs: faqs
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var talent_engine = (TalentEngineLandingPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,3955,1534,6129,9161,9092,2987,6248,7265,2590,9774,2888,179], function() { return __webpack_exec__(35456); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);